import * as yup from 'yup';

import { nameofFactory } from '@common/util/nameofFactory';
import { Job, UpdateJobInput } from '@controller/schema';

// export const NUMBER_RULES = [
//   {
//     rule: new RegExp(/^[0-9]{1,11}(?:\.[0-9]{1,3})?$/),
//     message: `${COMMON_VALIDATIONS.USERNAME_MIN} characters Minimum`,
//   },
// ];

export const JOB_FORM = {
  PUBLISHED_TO_APP: nameofFactory<Job>()('publishedToApp'),
  CLIENT_ID: nameofFactory<UpdateJobInput>()('clientId'),
  SUPPLIER_LIST: nameofFactory<UpdateJobInput>()('preferredSupplierList'),
  REFERENCE_ID: nameofFactory<Job>()('referenceId'),
  JOB_STATUS: nameofFactory<Job>()('jobStatus'),
  TITLE: nameofFactory<Job>()('title'),
  DETAILS: nameofFactory<Job>()('details'),
  SKILL_LIST: nameofFactory<Job>()('skillList'),
  ADDRESS: nameofFactory<Job>()('address'),
  LOCATION: nameofFactory<Job>()('location'),
  POST_CODE: nameofFactory<Job>()('postCode'),
  CITY: nameofFactory<Job>()('city'),
  CLIENT_COST: nameofFactory<Job>()('clientCost'),
  SUPPLIER_COST: nameofFactory<Job>()('supplierCost'),
  SLOT_DURATION: nameofFactory<Job>()('slotDuration'),
  JOB_DATE: 'jobDate',
  JOB_TIME: 'jobTime',
  SUPPLIER_ID: nameofFactory<UpdateJobInput>()('supplierId'),
  START_TIME: nameofFactory<Job>()('startTime'),
  PROPERTY_ACCESS: nameofFactory<Job>()('propertyAccess'),
  IMAGES: nameofFactory<Job>()('images'),
  DELETED_IMAGES: nameofFactory<UpdateJobInput>()('deletedImages'),
  VIDEOS: nameofFactory<Job>()('videos'),
  DELETED_VIDEOS: nameofFactory<UpdateJobInput>()('deletedVideos'),
  DELETED_DOCUMENTS: nameofFactory<UpdateJobInput>()('deletedDocuments'),

  INTERNAL_NOTES: nameofFactory<Job>()('internalNotes'),
  INVOICE_REF: nameofFactory<Job>()('invoiceRef'),

  SUPPLIER_JOB_STATUS: nameofFactory<Job>()('supplierJobStatus'),
  COMPLETION_IMAGES: nameofFactory<Job>()('completionImages'),
  COMPLETION_VIDEOS: nameofFactory<Job>()('completionVideos'),
  COMPLETION_DOCUMENTS: nameofFactory<Job>()('completionDocuments'),
  COMPLETION_NOTES: nameofFactory<Job>()('completionNotes'),

  REMEDIAL_NOTES: nameofFactory<Job>()('remedialNotes'),
  ADMIN_JOB_REPORT_NOTES: nameofFactory<Job>()('adminJobReportNotes'),

  LABOUR_COST: nameofFactory<Job>()('labourCost'),
  MATERIAL_COST: nameofFactory<Job>()('materialCost'),
  OTHER_COST: nameofFactory<Job>()('otherCost'),

  B2CNotes: nameofFactory<Job>()('b2cNotes'),

  PROBLEM_CATEGORY_ID: nameofFactory<Job>()('problemCategoryId'),
  PROBLEM_SUB_CATEGORY_ID: nameofFactory<Job>()('problemSubcategoryId'),
};

export const requiredValidation = (name: string) =>
  yup.string().required(`${name} is a required field`);

export const numberValidation = (name: string) =>
  yup
    .number()
    .typeError(`${name} is a Number field`)
    .required(`${name} is a required field`);

export const dateValidation = (name: string) =>
  yup.date().required(`${name} is a required field`);

export const objectValidation = (name: string) =>
  yup.object().nullable().required(`${name} is a required field`);

export const objectRequiredValidation = (name: string) =>
  yup.mixed().test({
    name: 'objectRequired',
    exclusive: true,
    message: `Select a ${name}`,
    test: (value) => {
      if (value === null || value === undefined) {
        return true;
      }
      return false;
    },
  });

export const createJobValidationSchema = yup.object().shape({
  [JOB_FORM.CLIENT_ID]: objectValidation('Client'),
  [JOB_FORM.JOB_STATUS]: objectValidation('Status'),
  [JOB_FORM.DETAILS]: requiredValidation('Details'),
  [JOB_FORM.SKILL_LIST]: yup
    .array()
    .min(1, 'Select at least one skill')
    .required(),
  [JOB_FORM.ADDRESS]: requiredValidation('Address'),
  location: objectValidation('Location'),
  [JOB_FORM.POST_CODE]: requiredValidation('Post Code'),
  [JOB_FORM.CITY]: objectValidation('City'),
  [JOB_FORM.CLIENT_COST]: numberValidation('Client Cost'),
  [JOB_FORM.SUPPLIER_COST]: numberValidation('Supplier Cost'),
  [JOB_FORM.JOB_DATE]: yup
    .array()
    .min(1, 'Select at least one Date when job can be started')
    .required(),
  [JOB_FORM.JOB_TIME]: yup
    .array()
    .min(1, 'Select at least one Time slot when job can be started')
    .required(),
  [JOB_FORM.PROBLEM_CATEGORY_ID]: objectValidation('Problem Category'),
  [JOB_FORM.PROBLEM_SUB_CATEGORY_ID]: objectValidation('Problem Subcategory'),
});
export const createPartialJobValidationSchema = yup.object().shape({
  [JOB_FORM.CLIENT_ID]: objectValidation('Client'),
  [JOB_FORM.JOB_STATUS]: objectValidation('Status'),
});

export const createJobClientValidationSchema = yup.object().shape({
  title: requiredValidation('Title'),
  details: requiredValidation('Details'),
  skillList: yup.array().min(1, 'Select at least one skill').required(),
  address: requiredValidation('Address'),
  location: objectValidation('Location'),
  postCode: requiredValidation('Post Code'),
  city: objectValidation('City'),
  // startTime: dateValidation('Start Time'),
});
